/**
 * Parse a Pingflo message that starts with /fixcode.
 * Keep in sync with Backend/src/services/fixcodeCommand.js.
 */

const COMMAND = /^\/fixcode\b/i;
const MESSAGE_MAX = 4000;

const KIND_WORDS = {
  bug: "bug",
  bugs: "bug",
  issue: "issue",
  issues: "issue",
  problem: "issue",
  probleme: "issue",
  improvement: "improvement",
  improvements: "improvement",
  improve: "improvement",
  idea: "improvement",
  idee: "improvement",
  feature: "improvement",
  amelioration: "improvement",
};

function stripAccents(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function isFixcodeCommand(text) {
  return COMMAND.test(String(text || "").trim());
}

function inferKind(message) {
  const n = stripAccents(message).toLowerCase();
  if (/\b(bug|crash|crashes|broken|error|erreur|casse|plante|plantage)\b/.test(n)) {
    return "bug";
  }
  if (
    /\b(improve|improvement|feature|idea|idee|ajouter|add|would be nice|serait bien|amelioration)\b/.test(
      n
    )
  ) {
    return "improvement";
  }
  return "issue";
}

export function parseFixcode(text) {
  const raw = String(text || "").trim();
  if (!isFixcodeCommand(raw)) {
    return { ok: false, reason: "not_command" };
  }
  const body = raw.replace(/^\/fixcode\b[:\s-]*/i, "").trim();
  if (!body) return { ok: false, reason: "empty" };

  const parts = body.split(/\s+/);
  const firstKey = stripAccents(parts[0]).toLowerCase();
  const explicit = KIND_WORDS[firstKey] || null;
  let kind = explicit;
  let message = body;
  if (explicit) {
    message = parts.slice(1).join(" ").trim();
    if (!message) return { ok: false, reason: "empty" };
  } else {
    kind = inferKind(body);
  }
  if (message.length > MESSAGE_MAX) message = message.slice(0, MESSAGE_MAX);
  return { ok: true, kind, message };
}
